<template>
  <md-card>
    <md-card-header data-background-color="primary">
      <h4 class="title">Atendimentos</h4>
      <p class="category">Lista de atendimentos abertos por você</p>
    </md-card-header>
    <md-card-content v-if="ticketsModel.length > 0">
      <md-table v-model="ticketsModel">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="#">{{ item.id }}</md-table-cell>
          <md-table-cell md-label="Protocolo">{{
            item.protocol
          }}</md-table-cell>
          <md-table-cell md-label="Tipo">{{
            formatTicketType(item.type)
          }}</md-table-cell>
          <md-table-cell md-label="Solicitante">{{ item.name }}</md-table-cell>
          <md-table-cell md-label="Solicitação">{{
            relative(item.createdAt)
          }}</md-table-cell>
          <md-table-cell md-label="Visualizar">
            <router-link :to="`tickets/${item.id}/view`">
              <md-icon>visibility</md-icon>
            </router-link>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
    <div v-else>
      <h2>Você não possui atendimentos!</h2>
    </div>
  </md-card>
</template>

<script>
import { formatRelative } from "date-fns";
import { ptBR } from "date-fns/locale";
import { mapActions } from "vuex";
import { formatTicketType } from "@/helpers";

export default {
  name: "ticket-list",
  computed: {
    tickets() {
      return this.$store.getters.tickets;
    }
  },
  data() {
    return {
      ticketsModel: []
    };
  },
  methods: {
    ...mapActions(["fetchTickets"]),
    relative(date) {
      const d = new Date(date);
      d.setHours(d.getHours() + 3);
      return formatRelative(d, new Date(), { locale: ptBR });
    },
    formatTicketType
  },
  async mounted() {
    this.ticketsModel = this.tickets;
    await this.fetchTickets();
    this.ticketsModel = this.tickets;
  }
};
</script>
<style scoped>
h2 {
  font-size: 25px;
  text-align: center;
  color: #8f8c8c;
  opacity: 0.7;
  user-select: none;
}
</style>
